import { LinearProgress } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { MdArrowForwardIos } from "react-icons/md";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { SERVER_URL } from "../../constant";

function TalentAquisation() {
  const isEmployee = useSelector(
    (state) => state.employee?.isEmployeeAuthenticated
  );
  const employeeDataForAccess = useSelector(
    (state) => state.employee?.employeeData
  );

  const navigate = useNavigate();

  //redirect to signin if not logged in
  useEffect(() => {
    if (isEmployee !== undefined && isEmployee === false) {
      navigate("/employee/signin");
    }
  }, [isEmployee]);

  //redirect to employee dashboard if permission is not given
  useEffect(() => {
    if (
      employeeDataForAccess !== null &&
      employeeDataForAccess?.admin?.talentAquisation === false
    ) {
      navigate("/employee/dashboard");
    }
  }, [employeeDataForAccess]);

  /* ----------------------------------------------------------------------------------------------------- */
  /* ----------------------------------------Main Coding Part--------------------------------------------- */
  /* ----------------------------------------------------------------------------------------------------- */
  const [newHiringReqNum, setNewHiringReqNum] = useState(0);
  const [loading, setLoading] = useState(false);

  // fetch hiring requests
  async function getNewHiringReq() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/total/new/request`,
        method: "get",
        withCredentials: true,
      });
      console.log(res.data?.data);
      setNewHiringReqNum(res.data?.data || 0);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getNewHiringReq();
  }, []);

  const optionsArr = [
    {
      title: "View All Hiring Request",
      link: "/admin/all/talent/aquisition/hiring/request/all",
      count: (
        <span className="ml-3 bg-red-500 px-[10px] py-1 rounded-full text-white text-center font-semibold text-[15px]">
          {newHiringReqNum} pending requests
        </span>
      )
    },
    {
      title: "View All Shortlisted Applicants for Interview",
      link: "/admin/talent/aquisation/final/discussion/shortlisted/applicants",
    },
  ];

  return (
    <>
      {loading && (
        <LinearProgress className="!fixed !top-0 !left-0 !right-0 !h-[8px]" />
      )}
      <div className="w-full flex justify-center items-center">
        <div className="w-[90vw] py-5">
          <h1 className="text-[30px] font-medium text-left w-full">
            Talent Aquisition & Screening
          </h1>
          <div className="w-full mt-5">
            <div className="rounded-[10px] border">
              {optionsArr.map((opt, i) => (
                <Link to={opt.link} key={i}>
                  <section
                    className={`p-3 flex justify-between items-center hover:bg-slate-50 ${
                      i === optionsArr.length - 1 ? "" : "border-b-[1px]"
                    }`}
                  >
                    <p className="text-slate-700 font-normal text-[17px]">
                      {opt.title} {newHiringReqNum > 0 ? opt?.count : ""}
                    </p>
                    <MdArrowForwardIos className="text-slate-500" />
                  </section>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default TalentAquisation;
